<div class="row">
  <form [formGroup]="form">
    <div class="col-12 form-group">
      <label>{{ 'user.email' | translate }}</label>
      <app-input-with-error
        [control]="this.form.controls['email']"
      ></app-input-with-error>
    </div>
    <div class="col-12 form-group">
      <label>{{ 'user.given_name' | translate }}</label>
      <app-input-with-error
        [control]="this.form.controls['given_name']"
      ></app-input-with-error>
    </div>
    <div class="col-12 form-group">
      <label>{{ 'user.family_name' | translate }}</label>
      <app-input-with-error
        [control]="this.form.controls['family_name']"
      ></app-input-with-error>
    </div>
    @if (assignableRoles.length > 1) {
      <div class="col-12 form-group">
        <label>{{ 'user.roles' | translate }}</label>
        <p-multiselect
          [options]="assignableRoles"
          formControlName="roles"
          optionValue="value"
          optionLabel="label"
          [showToggleAll]="false"
          [display]="'chip'"
          class="w-100"
        >
        </p-multiselect>
      </div>
    }
  </form>
  @if (allUserTable) {
    <div class="col-12 form-group">
      <label>{{ 'user.secondaryOrgs' | translate }}</label>
      <p-multiselect
        [options]="orgs"
        [ngModel]="secondaryOrgs"
        optionValue="id"
        [filter]="true"
        filterBy="name"
        [filterPlaceHolder]="'search' | translate"
        [selectionLimit]="MAX_SECONDARY_ORGANIZATIONS"
        [showClear]="true"
        [showToggleAll]="false"
        (ngModelChange)="limitSecondaryOrganizations($event)"
        optionLabel="name"
        class="w-100 md:w-80"
      >
      </p-multiselect>
    </div>
  }
  @if (value.id && value.isSecondaryOrgMember === false) {
    <div class="col-12 mt-3">
      <div class="border-top pt-3">
        @if (onboarding) {
          <div class="d-flex flex-wrap gap-2 mb-3" aria-live="polite">
            <span
              class="badge rounded-pill fw-normal"
              [class.bg-success-subtle]="onboarding.emailVerified"
              [class.text-success-emphasis]="onboarding.emailVerified"
              [class.bg-warning-subtle]="!onboarding.emailVerified"
              [class.text-warning-emphasis]="!onboarding.emailVerified"
            >
              {{
                (onboarding.emailVerified
                  ? 'onboarding.email_verified'
                  : 'onboarding.email_pending'
                ) | translate
              }}
            </span>
            <span
              class="badge rounded-pill fw-normal"
              [class.bg-success-subtle]="!onboarding.passwordSetupRequired"
              [class.text-success-emphasis]="!onboarding.passwordSetupRequired"
              [class.bg-warning-subtle]="onboarding.passwordSetupRequired"
              [class.text-warning-emphasis]="onboarding.passwordSetupRequired"
            >
              {{
                (onboarding.passwordSetupRequired
                  ? 'onboarding.password_pending'
                  : 'onboarding.password_complete'
                ) | translate
              }}
            </span>
          </div>
        }
        <div class="d-flex flex-wrap gap-2">
          <button
            type="button"
            class="btn btn-outline-primary btn-sm"
            [disabled]="
              passwordResetSending ||
              resetConfirmationOpen ||
              onboarding?.blocked
            "
            (click)="resetPasswordPrompt()"
          >
            @if (passwordResetSending) {
              <span
                class="spinner-border spinner-border-sm me-1"
                aria-hidden="true"
              ></span>
            }
            {{
              (passwordResetSending
                ? 'onboarding.sending'
                : 'user.reset_password'
              ) | translate
            }}
          </button>
          @if (
            onboarding &&
            !onboarding.blocked &&
            (!onboarding.emailVerified || onboarding.passwordSetupRequired)
          ) {
            <button
              type="button"
              class="btn btn-outline-primary btn-sm"
              [disabled]="invitationSending || invitationSent"
              (click)="resendInvitation()"
            >
              {{ 'onboarding.resend' | translate }}
            </button>
          }
        </div>
        @if (onboarding?.blocked) {
          <p class="small text-muted mt-2 mb-0">
            {{ 'onboarding.blocked' | translate }}
          </p>
        }
        @if (passwordResetSent) {
          <p class="small text-success mt-2 mb-0" role="status">
            {{ 'onboarding.reset_sent' | translate }}
          </p>
        }
        @if (invitationSent) {
          <p class="small text-success mt-2 mb-0" role="status">
            {{ 'onboarding.request_accepted' | translate }}
          </p>
        }
      </div>
    </div>
  }
</div>
<app-error [error]="error"></app-error>
